import * as ng from 'angular';
import {ValidDate} from './validate-date.directive';

export const ValidDateModule: string =
  ng.module('valid-date', [])
    .directive('validDate', ValidDate)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/validate-date/validate-date.module.ts